var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.645978 0.645917C0.692424 0.599354 0.747599 0.562411 0.808344 0.537205C0.86909 0.511998 0.934211 0.499023 0.999978 0.499023C1.06575 0.499023 1.13087 0.511998 1.19161 0.537205C1.25236 0.562411 1.30753 0.599354 1.35398 0.645917L7.35398 6.64592C7.40054 6.69236 7.43748 6.74754 7.46269 6.80828C7.4879 6.86903 7.50087 6.93415 7.50087 6.99992C7.50087 7.06568 7.4879 7.1308 7.46269 7.19155C7.43748 7.2523 7.40054 7.30747 7.35398 7.35392L1.35398 13.3539C1.26009 13.4478 1.13275 13.5005 0.999978 13.5005C0.867202 13.5005 0.739865 13.4478 0.645978 13.3539C0.552091 13.26 0.499346 13.1327 0.499346 12.9999C0.499346 12.8671 0.552091 12.7398 0.645978 12.6459L6.29298 6.99992L0.645978 1.35392C0.599415 1.30747 0.562472 1.2523 0.537265 1.19155C0.512059 1.13081 0.499084 1.06568 0.499084 0.999917C0.499084 0.93415 0.512059 0.869029 0.537265 0.808284C0.562472 0.747539 0.599415 0.692363 0.645978 0.645917Z",
    fill: "#194142"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallArrow);
export default __webpack_public_path__ + "static/media/small-arrow.d44bf4c1a36a226f1dac042c19c21de3.svg";
export { ForwardRef as ReactComponent };